import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { GetGPA } from './API';
 import { Translate } from 'react-localize-redux';
export default class Achievement extends Component {

    FetchData = () => {
        GetGPA(this.props.batchNum).then(data => {
            console.log(data)
            this.setState({ data: data, loading: false });
        })
    }
    constructor(props) {
        super(props);
        this.state = { data: [], };
        this.FetchData()


    }
    componentDidUpdate(prevProps) {
        if (prevProps.batchNum !== this.props.batchNum)
            this.FetchData();
    }


    render() {
        return (
            <div class="row">
                <div class="col-xs-12 col-sm-3"></div>
                <div class="col-xs-12 col-sm-6">
                    <div class="card">
                        <div class="card-block">
                            <h4 class="card-title m-t-0"> <Translate id="achievement.desc" /></h4>
                            <h6 class="card-subtitle m-b-10 text-muted"></h6>
                            <table class="gv gv_gpa">
                                <tbody>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col"><Translate id="achievement.credit" /></th>
                                        <th scope="col"><Translate id="achievement.gpa" /> </th>


                                    </tr>
                                    <tr>
                                        <td><Translate id="achievement.term" /> </td>
                                        <td>{this.state.data.termHours}</td>
                                        <td>{this.state.data.termsGPA}</td>

                                    </tr>
                                    <tr>
                                        <td><Translate id="achievement.total" /></td>
                                        <td>{this.state.data.accumHours}</td>
                                        <td>{this.state.data.accumGPA}</td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/results/Achievement.js